export default __webpack_public_path__ + "static/media/sponsor-bg-1-id.0565880e.webp";